import { html } from '../html.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr, money } from './parts.js';
const KIND_LABEL = {
    invoice: 'kindInvoice',
    receipt: 'kindReceipt',
    credit_note: 'kindCreditNote',
    payment: 'kindPayment',
    purchase_invoice: 'kindPurchaseInvoice',
    purchase_return: 'kindPurchaseReturn',
};
/**
 * CRM-04's statement, printed.
 *
 * The arithmetic is NOT redone here. Opening balance, every row's running
 * balance and the closing balance arrive already computed by
 * `PartnersService.statement()` — the same numbers the screen shows and the
 * same numbers the emailed statement quotes (R9: POSTED documents only). A
 * template that re-derived a running balance would be a second implementation
 * of the one figure a customer will ring up about.
 */
export function partnerStatementHtml(data, locale, company, generatedAt, generatedBy) {
    const c = data.currency;
    const title = t(data.side === 'supplier' ? 'statementSupplier' : 'statementCustomer', locale);
    return html `
    ${header(company, title, null)}
    ${fields([
        field(t('customerCode', locale), ltr(data.partnerCode)),
        field(t('asOf', locale), docDate(data.asOf)),
    ])}
    <section class="doc-party">
      <div class="label">${title}</div>
      <div class="name">${data.partnerName}</div>
    </section>

    <table class="doc-table">
      <thead>
        <tr>
          <th>${t('date', locale)}</th>
          <th>${t('reference', locale)}</th>
          <th>${t('description', locale)}</th>
          <th class="amount">${t('debit', locale)}</th>
          <th class="amount">${t('credit', locale)}</th>
          <th class="amount">${t('balance', locale)}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td></td>
          <td></td>
          <td>${t('openingBalance', locale)}</td>
          <td class="amount"></td>
          <td class="amount"></td>
          <td class="amount">${money(data.openingBalance, c)}</td>
        </tr>
        ${data.rows.length === 0
        ? html `<tr><td class="doc-empty" colspan="6">${t('noRows', locale)}</td></tr>`
        : data.rows.map((row) => html `
                <tr>
                  <td>${docDate(row.date)}</td>
                  <td>${ltr(row.code)}</td>
                  <td>${t(KIND_LABEL[row.kind], locale)}</td>
                  <td class="amount">${money(row.debit, c)}</td>
                  <td class="amount">${money(row.credit, c)}</td>
                  <td class="amount">${money(row.balance, c)}</td>
                </tr>
              `)}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5">${t('closingBalance', locale)}</td>
          <td class="amount">${money(data.closingBalance, c)}</td>
        </tr>
      </tfoot>
    </table>
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=partner-statement.js.map